/**
 * H5项目配置入口
 */
const Host = `${window.location.protocol}//${window.location.host}`;

export default {
  title: '洗车美容',
  appRootEle: 'root',
  pages: [{
      title: '洗车美容',
      hash: '/',
      path: 'pages/home/index'
    },{
      title: '门店详情',
      hash: '/store',
      path: 'pages/store/index'
    },
    {
      title: '门店筛选',
      hash: '/carWash',
      path: 'pages/carWash/index'
    },
    {
      title: '地图导航',
      hash: '/storeMap',
      path: 'pages/storeMap/index'
    },{
      title: '订单详情',
      hash: '/orderDetail',
      path: 'pages/orderDetail/index'
    },{
      title: '订单支付',
      hash: '/orderPay',
      path: 'pages/orderPay/index'
    },{
      title: '订单支付',
      hash: '/wxPay',
      path: 'pages/wxPay/index'
    },{
      title: '支付结果',
      hash: '/payStatus',
      path: 'pages/payStatus/index'
    },{
      title: '选择城市',
      hash: '/citySelect',
      path: 'pages/citySelect/index'
    },
    {
      title: '我的订单',
      hash: '/orderList',
      path: 'pages/orderList/index'
    },
    {
      title: '提交订单',
      hash: '/submitOrder',
      path: 'pages/submitOrder/index'
    },
    {
      title: '加油站列表',
      hash: '/gas',
      path: 'pages/gas/index'
    },
    {
      title: '加油站详情',
      hash: '/gasStation',
      path: 'pages/gasStation/index'
    },
    {
      title: '加油站详情',
      hash: '/gasRedirect',
      path: 'pages/gasRedirect/index'
    },
    {
      title: '加油站地图',
      hash: '/gasMapMode',
      path: 'pages/gasMapMode/index'
    },
    {
      title: '物流详情',
      hash: '/orderExpress',
      path: 'pages/orderExpress/index'
    },
    {
      title: '【车轮】小保养',
      hash: '/upkeep',
      path: 'pages/upkeep/index'
    },
    {
      title: '加油流程',
      hash: '/gasSteps',
      path: 'pages/gasSteps/index'
    },
    {
      title: '选择门店',
      hash: '/storeSelect',
      path: 'pages/storeSelect/index'
    },
    {
      title: '收货地址',
      hash: '/myAddress',
      path: 'pages/myAddress/index'
    },
    {
      title: '添加收货地址',
      hash: '/addressEdit',
      path: 'pages/addressEdit/index'
    },
    {
      title: '我的车库',
      hash: '/myGarage',
      path: 'pages/myGarage/index'
    },
    {
      title: '活动说明',
      hash: '/activityRules',
      path: 'pages/activityRules/index'
    },
    {
      title: '',
      hash: '/routerBack',
      path: 'pages/routerBack/index'
    },
  ],
  // 打点统计前缀 prefix
  statEventPrefix: 'use-car1.1',
  //项目url
  baseUrl:`${Host}/car-service/use-car/#`,
  //默认报错提示
  errorMsg:'系统繁忙，请稍后重试',
  // 百度统计ID
  baiduCountID: 'cb9bd9d99b80e6c533943ecebbfbb151', //账号 clstrick8
  Host : Host,
  //洗车美容分享配置
  // shareInfo: {
  //   title: '【车轮】洗车美容', // 分享标题
  //   desc: '洗车、美容、喷漆...更多车主服务尽在车轮', // 分享描述
  //   link: Host+'/car-service/use-car/index.html', // 分享链接[未知]
  //   imgUrl: 'https://static.clfile.com/g2/img/p/act-img/ycfw/xcmr.jpg',
  //   type: 'link', // 分享类型,music、video或link，不填默认为link
  //   dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
  // },
  //八周年的分享文案
  shareInfo: {
    title: '【9.9元洗车】火热抢购中', // 分享标题
    desc: '海量优惠尽在车轮！', // 分享描述
    link: Host+'/car-service/use-car/index.html', // 分享链接[未知]
    imgUrl: 'https://static.clfile.com/g2/img/p/jiangwei/9.9xiche.png',
    type: 'link', // 分享类型,music、video或link，不填默认为link
    dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
  },

  //加油站分享配置
  gasShareInfo: {
    title: '【车轮】这里92＃汽油全国直降0.63元！',
    desc: '点击查看附近有优惠的加油站>>>',
    link: Host+'/car-service/use-car/index.html#/gas', // 分享链接[未知]
    imgUrl: 'https://static.clfile.com/g2/img/p/act-img/ycfw/gas-share-img.jpg',
    type: 'link', // 分享类型,music、video或link，不填默认为link
    dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
  },

  //小保养分享配置
  upkeepShareInfo: {
    title: '【车轮】小保养',
    desc: '保养、洗车、美容...更多车主服务尽在车轮',
    link: Host+'/car-service/use-car/index.html#/upkeep', // 分享链接[未知]
    imgUrl: 'https://static.clfile.com/g2/img/p/act-img/ycfw/upkeep-share-img.jpg',
    type: 'link', // 分享类型,music、video或link，不填默认为link
    dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
  },

  //暂停营业下单提示
  suspendTips:'该门店目前暂停营业中，下单后暂时无法体验服务，请确认是否继续下单？',
  // 是否开启fastclick
  isFastClick: false,
  CHELUN_SHOW_OPTION_MENU: 1, //0不显示 1显示，整数， 默认显示
  // http://doc.oa.com/pages/viewpage.action?pageId=6521734
  CHELUN_SHOW_MENU_ITEMS: ["menu:refresh","menu:share:wxMessage","menu:share:wxTimeline","menu:share:qq","menu:share:sina","menu:share:sms"],
  // 是否使用Redux
  useRedux: true,
}